import Component from "../../lib/component";

export const ImageMetadataConfig = {
    componentTypeKey: 'imageMetadata',
    baseHtmlClass: 'image_metadata',
    selector: '.image_metadata',

    datasetConfigKey: 'image_metadata__config',
    alwaysOpenDatasetConfigKey: 'always_open',
    zoomUrlDatasetConfigKey: 'zoom_url',
};

export class ImageMetadata extends Component {

    constructor(id_or_element) {
        super({
            element: id_or_element,
            config: ImageMetadataConfig
        });

        this.setDatasetConfig(ImageMetadataConfig.datasetConfigKey);
        this.alwaysOpen = this.datasetConfig[ImageMetadataConfig.alwaysOpenDatasetConfigKey];
        this.zoomUrl = this.getZoomUrl();
        this.open = (this.alwaysOpen ? true : false);

        this.element.addEventListener('click', this.handleClick.bind(this));

        this.render();
    }


    handleClick(event) {
        if (!this.alwaysOpen) {
            event.stopPropagation();
            this.open ? this.open = false : this.open = true;
        } else if (this.zoomUrl) {
            window.open(this.zoomUrl, '_blank').focus();
        }
        this.render();
    }

    render() {
        this.conditionallySetHtmlClassState(this.alwaysOpen, 'always_open');
        if (!this.alwaysOpen) {
            this.conditionallySetHtmlClassState(this.open, 'open');
            this.conditionallySetHtmlClassState(!this.open, 'closed');
        }
    }

    // This basically just validates the URL is not malformed.
    getZoomUrl() {
        const url = this.datasetConfig[ImageMetadataConfig.zoomUrlDatasetConfigKey];
        let zoomUrl = null;
        try {
            zoomUrl = new URL(url);
        } catch (TypeError) { // Generally because the `url` is a relative url and a URL instance needs a base set.
            zoomUrl = new URL(url, `${window.location.protocol}//${window.location.host}`);
        }
        return zoomUrl;
    }
}

